import { ConversationAuditLogEntry } from 'apis/auditLogs';
import { AppLink } from 'components/appLink';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationLinkedProps = {
  entry: ConversationAuditLogEntry<
    | 'CONVERSATION_LINKED_FROM_CHILD'
    | 'CONVERSATION_UNLINKED_FROM_CHILD'
    | 'CONVERSATION_LINKED_TO_PARENT'
    | 'CONVERSATION_UNLINKED_TO_PARENT'
  >;
};

export const ConversationLinked = ({
  entry,
}: ConversationLinkedProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const isLinkFromChild =
    entry.activity_type === 'CONVERSATION_LINKED_FROM_CHILD' ||
    entry.activity_type === 'CONVERSATION_UNLINKED_FROM_CHILD';
  const linkCsid = `${isLinkFromChild ? entry.child : entry.parent}`;

  const actionType =
    entry.activity_type === 'CONVERSATION_LINKED_TO_PARENT' ||
    entry.activity_type === 'CONVERSATION_LINKED_FROM_CHILD'
      ? 'linked'
      : 'unlinked';
  const preposition = actionType === 'linked' ? 'to' : 'from';

  const authorLink = <UserLink userId={entry.author.id}>{authorName}</UserLink>;
  const conversationLink = (
    <AppLink path={`/conversation/:csid`} params={{ path: { csid: linkCsid } }}>
      #{linkCsid}
    </AppLink>
  );

  const text = isLinkFromChild ? (
    <>
      Conversation {conversationLink} has been {actionType} by {authorLink}
    </>
  ) : (
    <>
      Conversation has been {actionType} {preposition} a main conversation{' '}
      {conversationLink} by {authorLink}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
